import moment from 'moment';
import React from 'react';
import {
  Banner,
  Button,
  CondensedMedium,
  Flashy,
  Form,
  Gutter,
  Icon,
  Layout,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalSection,
  Textarea,
} from '@axiom/ui';

import { DirectEngagementsFormIntakeSuggestionModalSchema } from './direct-engagements-form-intake-suggestion-modal-schema';

const getDateThreeMonthsFromNow = () =>
  moment().add(3, 'months').format('MMMM Do YYYY');

export type DirectEngagementsFormIntakeSuggestionModalProps = {
  onClose: () => void;
  onContinue: (intakeDescription: string) => void;
};

export const DirectEngagementsFormIntakeSuggestionModal = ({
  onClose,
  onContinue,
}: DirectEngagementsFormIntakeSuggestionModalProps) => {
  return (
    <Form
      name="intake-suggest-form"
      schema={DirectEngagementsFormIntakeSuggestionModalSchema}
      initialValues={{ intakeDescription: null }}
      onSubmit={(_, __, values) => {
        const trimmedIntakeDescription = values.intakeDescription?.trim();
        if (!trimmedIntakeDescription) {
          onClose();
          return;
        }

        onContinue(trimmedIntakeDescription);
      }}
    >
      {({ fireSubmit }) => (
        <Modal name="intake-suggest-modal">
          <ModalHeader
            name="intake-suggest-modal-header"
            onClose={() => {
              onClose();
            }}
          >
            <Layout
              direction="horizontal"
              verticalGutter="8px"
              position="middle"
            >
              <Flashy color="iconAssistant">
                <Icon name="intelligence-filled" />
              </Flashy>
              <Gutter right="8px" />
              Briefly describe your legal needs
            </Layout>
          </ModalHeader>
          <ModalSection name="intake-suggest-modal-section">
            <Textarea
              name="intakeDescription"
              label="Legal needs"
              description="Provide a job description to help us understand your legal needs. We'll pre-fill these details on the next step to save you some time."
            />
            <Gutter top="16px">
              <Banner type="info" name="intake-suggest-banner">
                <CondensedMedium>
                  <Flashy bold>Job description example:</Flashy> We need a
                  lawyer with experience in Financial Services and the Banking
                  industry for approximately 20 hours per week for 3 months,
                  beginning on {getDateThreeMonthsFromNow()}. They will work
                  remotely and handle supporting any legal work that arises
                  within a commercial bank.
                </CondensedMedium>
              </Banner>
            </Gutter>
          </ModalSection>
          <ModalFooter stackableOn="mobile">
            <Button
              name="intake-suggest-skip-button"
              variation="outline"
              onClick={() => {
                onClose();
              }}
            >
              SKIP
            </Button>
            <Button
              name="intake-suggest-continue-button"
              variation="filled"
              pattern="primary"
              onClick={fireSubmit}
            >
              CONTINUE
            </Button>
          </ModalFooter>
        </Modal>
      )}
    </Form>
  );
};
